import { Component, Inject, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { HColor } from '@shared/src/datatypes/HColor';
import { HomeController } from "@shared/src/controllers/home/home.controller";
import { HDateHour } from '@shared/src/datatypes/HDateHour';
import { TruckingShipmentDto } from '@shared/src/dtos/trucking/TruckingShipmentDto';
import { TruckingController } from '@shared/src/controllers/trucking/trucking.controller';
import { TruckingShipmentPackageDto } from '@shared/src/dtos/trucking/TruckingShipmentPackageDto';
import { TruckingRouteExpandDto } from '@shared/src/dtos/trucking/TruckingRouteExpandDto';
import { ActionDto } from '@shared/src/dtos/maintenance/action/actionDto';
import { ActionsStripDto } from '@shared/src/dtos/maintenance/action/ActionsStripDto';
import { TruckingRouteExecuteActionDto } from '@shared/src/dtos/trucking/TruckingRouteExecuteActionDto';
import { TruckingRouteActions } from '@shared/src/enums/TruckingRouteActions';
import { HLong } from '@shared/src/datatypes/HLong';
import { desplegarAvall, fadeInOut } from '@shared/src/animations';

@Component({
    selector: 'shared-trucking-shipment-card',
    templateUrl: './shared.trucking.shipment.card.html',
    styleUrls: ['./shared.trucking.shipment.card.scss'],
    animations: [desplegarAvall, fadeInOut]
})
export class SharedTruckingShipmentCard implements OnInit {

    constructor(@Inject('HomeController') protected homeController: HomeController,
        public truckingController: TruckingController) {

    }

    private _selectedRouteExpand: TruckingRouteExpandDto;
    @Input()
    public set selectedRouteExpand(value: TruckingRouteExpandDto) {
        if (this._selectedRouteExpand === value)
            return;
        this._selectedRouteExpand = value;
        this.loadActions();
    }
    public get selectedRouteExpand(): TruckingRouteExpandDto {
        return this._selectedRouteExpand;
    }

    private _shipment: TruckingShipmentDto;
    @Input()
    public set shipment(value: TruckingShipmentDto) {
        if (this._shipment === value)
            return;
        this._shipment = value;
        this.loadActions();
    }
    public get shipment(): TruckingShipmentDto {
        return this._shipment;
    }

    @Input()
    public filterKeys: String[];

    private _showPackages: boolean;
    public set showPackages(value: boolean) {
        if (this._showPackages === value)
            return;
        this._showPackages = value;
        if (this._showPackages) {
            if (this._shipment != null && !HLong.isNullOrNullLong(this._shipment.shipmentId)) {
                if (this.filterKeys == null)
                    this.filterKeys = new Array();
                this.truckingController.getTruckingShipment(this._shipment.shipmentId, this.filterKeys).subscribe(data => {
                    this._shipment = data;
                });
            } else {
                this._shipment = null;
            }
        }
    }
    public get showPackages(): boolean {
        return this._showPackages;
    }

    ngOnInit(): void {

    }

    loadActions() {
        this.actions = new ActionsStripDto();
        if (this.shipment == null)
            return;
        if (!this.shipment.isTrucking) {
            this.actions.add(SharedTruckingShipmentCard.TRUCKING);
            if (this.selectedRouteExpand != null && !this.selectedRouteExpand.isBrokenForTrucking && this.selectedRouteExpand.isTrucked)
                this.actions.add(SharedTruckingShipmentCard.ADDSHIPMENTINROUTE);
        }
    }

    @Output() clickCard = new EventEmitter<TruckingShipmentDto>();
    onClickCard(event) {
        if (event && event.stopPropagation)
            event.stopPropagation();

        this.clickCard.next(this.shipment);
    }

    getTagColor(tag: string): string {
        return HColor.getColorFromStringTable(tag, this.homeController);
    }

    dateIsNull(d: HDateHour): Boolean {
        return HDateHour.isNullOrNullValue(d);
    }

    datesAreEqual(a: HDateHour, b: HDateHour): boolean {
        return HDateHour.equals(a, b);
    }

    onClickOpenPackages(event) {
        if (event && event.stopPropagation)
            event.stopPropagation();
        this.showPackages = true;
    }

    onClickClosePackages(event) {
        if (event && event.stopPropagation)
            event.stopPropagation();
        this.showPackages = false;
    }


    public selectedPackage: TruckingShipmentPackageDto;
    onClickPackage(event, item: TruckingShipmentPackageDto) {
        if (event && event.stopPropagation)
            event.stopPropagation();

        this.selectedPackage = item;
    }

    onClickPackageDetail(item: TruckingShipmentPackageDto) {
        if (item == null || this.shipment == null || this.shipment.packages == null)
            return;

        this.shipment.packages.forEach(element => {
            if (element.packageId != item.packageId)
                element.showDetail = false;
        });
    }

    onRefreshShipment(value: boolean) {
        if (value && this._shipment && !HLong.isNullOrNullLong(this._shipment.shipmentId)) {
            this.truckingController.getTruckingShipment(this._shipment.shipmentId, this.filterKeys).subscribe(data => {
                this._shipment = data;
                if (this._shipment != null && (this._shipment.packages == null || this._shipment.packages.length == 0))
                    this.truckingController.refreshShipmentList$.next(true);
            });
        }
    }

    public actions: ActionsStripDto;
    onClickAction($event: ActionDto) {
        if ($event == null)
            return;
        switch ($event.actionId) {
            case 'TRUCKING':
                this.onTruckingClick();
                break;
            case 'ADDSHIPMENTINROUTE':
                this.addShipmentInRouteClick();
                break;
        }
    }
    onTruckingClick() {
        if (this._shipment == null)
            return;

        this.truckingController.executeAction(TruckingRouteExecuteActionDto.build(TruckingRouteActions.TruckingShipment, 0, this._shipment.shipmentId, 0)).subscribe(data => {
            if (data) {
                this.truckingController.refreshShipmentList$.next(true);
                this.truckingController.refreshRouteList$.next(true);
            }
        });

    }

    addShipmentInRouteClick() {
        if (this.selectedRouteExpand == null || this._shipment == null)
            return;

        this.truckingController.executeAction(TruckingRouteExecuteActionDto.build(TruckingRouteActions.AddShipment, this.selectedRouteExpand.routeId, this._shipment.shipmentId, 0)).subscribe(data => {
            if (data) {
                this.truckingController.refreshShipmentList$.next(true);
                this.truckingController.routeChanged$.next(this.selectedRouteExpand.routeId);
            }
        });

    }

    public static TRUCKING: ActionDto = ActionDto.build("TRUCKING", "TRUCKING.SHIPMENT.ACTIONS.TRUCKING.CAPTION", "TRUCKING.SHIPMENT.ACTIONS.TRUCKING.HELP", "fa-plus-circle", 20, 0, 0, "").addClass("");
    public static ADDSHIPMENTINROUTE: ActionDto = ActionDto.build("ADDSHIPMENTINROUTE", "TRUCKING.SHIPMENT.ACTIONS.ADDSHIPMENTINROUTE.CAPTION", "TRUCKING.SHIPMENT.ACTIONS.ADDSHIPMENTINROUTE.HELP", "fa-share", 10, 0, 0, "").addClass("action");

}
